export enum ValidateFormErrorMessages {
  required = "Обязательное поле",
  enterCorrectEmail = "Введите корректный Email",
  phoneFormatMessage = "Неверный формат номера",
}
